import vmClient from 'app/services/vmClient';
import { Entity, EntityStringId, IEntityType, IEntity } from '../../types/entity';
import { ITextTranslation, TextTranslation } from './TextTranslation';
import { Language, LanguageMarshaller } from 'app/constants/enums/Language';

export interface ICommonText extends IEntity {
  attributes: {
    formatted: boolean;
    id: EntityStringId;
    text: string;
    language: Language;
    usage: string | null;
  };
  associations: {
    textTranslations: ITextTranslation[];
  };
}

export type CommonText = Entity<ICommonText>;
// defineClass is a class factory, normally classes create a runtime variable and identifier in the type namespace.
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CommonText: IEntityType<ICommonText> = vmClient.defineClass({
  typeName: 'CommonText',
  version: 2,
  lockable: true,
  persisted: true,
  attributes: {
    formatted: 'boolean',
    text: {
      type: 'string',
      notNull: true,
    },
    language: {
      type: Language,
      marshaller: LanguageMarshaller,
      notNull: true,
    },
    usage: 'string',
  },
  associations: {
    textTranslations: {
      collection: true,
      type: TextTranslation,
    },
  },
});
